import './Score.scoped.scss'

export default function Score({ response, setResponse, name, settings, className = '' }) {
  const isDashboard = useSel(s => !!s.dashboard?.id)

  const handleChange = (event) => {
    if (event.target.checked) {
      setResponse(+event.target.value);
    }
  }

  const options = (new Array((settings.max || 10) - (settings.min || 0)+1))
    .fill(0).map((item, index) => index + (settings.min || 0))

  if (isDashboard) {
    return <div className={`answers dropdown ${className}`}>
      <select
        name={name}
        value={response ?? ''}
        onChange={e => setResponse(e.target.value === "" ? null : +e.target.value)}
      >
        <option value="">Select...</option>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  }

  return (
    <div className={`answers ${className}`}>
      {options.map((option) => (
        <label key={option} className={`${option === response ? 'selected' : ''}`}>
          <input type="radio" 
            name={name}
            value={option} 
            checked={option === response}
            onChange={handleChange} />
          <span>{option}</span>
        </label>
      ))}
    </div>
  )
}
